module.exports = __webpack_public_path__ + "static/LogoUFFS-f0f672c4758abfe1240216cd689c42a9.png";